export const getResourceRichTextError = (
  value: unknown
): string | undefined => {
  if (typeof value !== 'string') return 'Enter text';
  const doc = new DOMParser().parseFromString(value, 'text/html');
  if (doc.querySelector('img, picture, svg, image'))
    return 'Images are not allowed';
  doc
    .querySelectorAll('script, style, template')
    .forEach((node) => node.remove());
  return (doc.body.textContent ?? '').replace(/[\s\u200B-\u200D\uFEFF]/gu, '')
    .length > 0
    ? undefined
    : 'Enter text';
};
